// src/utils/emojiMapping.ts

import angelGif from '../assets/emojis/angel.gif';
import beatingHeartGif from '../assets/emojis/beating_heart.gif';
import beerCheersGif from '../assets/emojis/beer_cheers.gif';
import bigBrightSmileGif from '../assets/emojis/big_bright_smile.gif';
import bigTeethSmileGif from '../assets/emojis/big_teeth_smile.gif';
import bombGif from '../assets/emojis/bomb.gif';
import catchKissGif from '../assets/emojis/catch_kiss.gif';
import coverMouthGiggleGif from '../assets/emojis/cover_mouth_giggle.gif';
import crazyLookingSmileyGif from '../assets/emojis/crazy_looking_smiley.gif';
import crazyLoveGif from '../assets/emojis/crazy_love.gif';
import cryingWithRedHankyGif from '../assets/emojis/crying_with_red_hanky.gif';
import dancingGif from '../assets/emojis/dancing.gif';
import devilGif from '../assets/emojis/devil.gif';
import dontThinkSoGif from '../assets/emojis/dont_think_so.gif';
import giveHerAKissGif from '../assets/emojis/give_her_a_kiss.gif';
import giveMeAKissGif from '../assets/emojis/give_me_a_kiss.gif';
import givingAWinkGif from '../assets/emojis/giving_a_wink.gif';
import hugeThumbsUpGif from '../assets/emojis/huge_thumbs_up.gif';
import idkGif from '../assets/emojis/idk.gif';
import innocentLookingGif from '../assets/emojis/innoncent_looking.gif';
import insanelyRollingEyesGif from '../assets/emojis/insanely_rolling_eyes.gif';
import laughingVeryHardGif from '../assets/emojis/laughing_very_hard.gif';
import lookingUpAndThinkingGif from '../assets/emojis/looking_up_and_thinking.gif';
import musicGif from '../assets/emojis/music.gif';
import notFeelingWellGif from '../assets/emojis/not_feeling_well.gif';
import oldSchoolDanceGif from '../assets/emojis/old_school_dance.gif';
import playingGameGif from '../assets/emojis/playing_game.gif';
import reasoningOutGif from '../assets/emojis/reasoning_out.gif';
import removingBlackHatGif from '../assets/emojis/removing_black_hat.gif';
import rollingOnTheFloorGif from '../assets/emojis/rolling_on_the_floor.gif';
import roseForYouGif from '../assets/emojis/rose_for_you.gif';
import sadFacedGif from '../assets/emojis/sad_faced.gif';
import scratchesHeadGif from '../assets/emojis/scratches_head.gif';
import shokedGif from '../assets/emojis/shoked.gif';
import showingHugeTeethGif from '../assets/emojis/showing_huge_teeth.gif';
import sighOfReliefGif from '../assets/emojis/sigh_of_relief.gif';
import smileyRunningAwayGif from '../assets/emojis/smiley_running_away.gif';
import smileyWithShadesGif from '../assets/emojis/smiley_with_shades.gif';
import stikingTongueOutGif from '../assets/emojis/stiking_tongue_out.gif';
import thumbsUpGif from '../assets/emojis/thumbs_up.gif';
import tiedUpGif from '../assets/emojis/tied_up.gif';
import tryingToLookInnocentGif from '../assets/emojis/trying_to_look_innoncent.gif';
import yourFaultGif from '../assets/emojis/your_fault.gif';

export interface CustomEmoji {
  id: string;
  name: string;
  src: string;
  unicodeEmojis: string[];
  description: string;
}

export const customEmojis: CustomEmoji[] = [
  {
    id: 'angel',
    name: 'angel',
    src: angelGif,
    unicodeEmojis: ['😇'],
    description: 'Ангел',
  },
  {
    id: 'beating_heart',
    name: 'beating_heart',
    src: beatingHeartGif,
    unicodeEmojis: ['💓'],
    description: 'Бьющееся сердце',
  },
  {
    id: 'beer_cheers',
    name: 'beer_cheers',
    src: beerCheersGif,
    unicodeEmojis: ['🍻'],
    description: 'Пиво/Чокаемся',
  },
  {
    id: 'big_bright_smile',
    name: 'big_bright_smile',
    src: bigBrightSmileGif,
    unicodeEmojis: ['😃'],
    description: 'Большая улыбка',
  },
  {
    id: 'big_teeth_smile',
    name: 'big_teeth_smile',
    src: bigTeethSmileGif,
    unicodeEmojis: ['😆'],
    description: 'Улыбка с зубами',
  },
  {
    id: 'bomb',
    name: 'bomb',
    src: bombGif,
    unicodeEmojis: ['💣'],
    description: 'Бомба',
  },
  {
    id: 'catch_kiss',
    name: 'catch_kiss',
    src: catchKissGif,
    unicodeEmojis: ['😘'],
    description: 'Ловить поцелуй',
  },
  {
    id: 'cover_mouth_giggle',
    name: 'cover_mouth_giggle',
    src: coverMouthGiggleGif,
    unicodeEmojis: ['🤭'],
    description: 'Прикрывает рот и хихикает',
  },
  {
    id: 'crazy_looking_smiley',
    name: 'crazy_looking_smiley',
    src: crazyLookingSmileyGif,
    unicodeEmojis: ['🤪'],
    description: 'Сумасшедший смайлик',
  },
  {
    id: 'crazy_love',
    name: 'crazy_love',
    src: crazyLoveGif,
    unicodeEmojis: ['😍'],
    description: 'Безумная любовь',
  },
  {
    id: 'crying_with_red_hanky',
    name: 'crying_with_red_hanky',
    src: cryingWithRedHankyGif,
    unicodeEmojis: ['😭'],
    description: 'Плачет с платочком',
  },
  {
    id: 'dancing',
    name: 'dancing',
    src: dancingGif,
    unicodeEmojis: ['💃'],
    description: 'Танцует',
  },
  {
    id: 'devil',
    name: 'devil',
    src: devilGif,
    unicodeEmojis: ['😈'],
    description: 'Дьявол',
  },
  {
    id: 'dont_think_so',
    name: 'dont_think_so',
    src: dontThinkSoGif,
    unicodeEmojis: ['🙄'],
    description: 'Не думаю',
  },
  {
    id: 'give_her_a_kiss',
    name: 'give_her_a_kiss',
    src: giveHerAKissGif,
    unicodeEmojis: ['😗'],
    description: 'Поцеловать её',
  },
  {
    id: 'give_me_a_kiss',
    name: 'give_me_a_kiss',
    src: giveMeAKissGif,
    unicodeEmojis: ['😙'],
    description: 'Поцелуй меня',
  },
  {
    id: 'giving_a_wink',
    name: 'giving_a_wink',
    src: givingAWinkGif,
    unicodeEmojis: ['😉'],
    description: 'Подмигивает',
  },
  {
    id: 'huge_thumbs_up',
    name: 'huge_thumbs_up',
    src: hugeThumbsUpGif,
    unicodeEmojis: ['👍'],
    description: 'Большой лайк',
  },
  {
    id: 'idk',
    name: 'idk',
    src: idkGif,
    unicodeEmojis: ['🤷'],
    description: 'Не знаю',
  },
  {
    id: 'innocent_looking',
    name: 'innocent_looking',
    src: innocentLookingGif,
    unicodeEmojis: ['🥺'],
    description: 'Невинный взгляд',
  },
  {
    id: 'insanely_rolling_eyes',
    name: 'insanely_rolling_eyes',
    src: insanelyRollingEyesGif,
    unicodeEmojis: ['😒'],
    description: 'Закатывает глаза',
  },
  {
    id: 'laughing_very_hard',
    name: 'laughing_very_hard',
    src: laughingVeryHardGif,
    unicodeEmojis: ['🤣'],
    description: 'Очень сильно смеётся',
  },
  {
    id: 'looking_up_and_thinking',
    name: 'looking_up_and_thinking',
    src: lookingUpAndThinkingGif,
    unicodeEmojis: ['🤔'],
    description: 'Думает',
  },
  {
    id: 'music',
    name: 'music',
    src: musicGif,
    unicodeEmojis: ['🎵'],
    description: 'Музыка',
  },
  {
    id: 'not_feeling_well',
    name: 'not_feeling_well',
    src: notFeelingWellGif,
    unicodeEmojis: ['🤒'],
    description: 'Плохо себя чувствует',
  },
  {
    id: 'old_school_dance',
    name: 'old_school_dance',
    src: oldSchoolDanceGif,
    unicodeEmojis: ['🕺'],
    description: 'Олдскульный танец',
  },
  {
    id: 'playing_game',
    name: 'playing_game',
    src: playingGameGif,
    unicodeEmojis: ['🎮'],
    description: 'Играет в игру',
  },
  {
    id: 'reasoning_out',
    name: 'reasoning_out',
    src: reasoningOutGif,
    unicodeEmojis: ['💭'],
    description: 'Размышляет',
  },
  {
    id: 'removing_black_hat',
    name: 'removing_black_hat',
    src: removingBlackHatGif,
    unicodeEmojis: ['🎩'],
    description: 'Снимает шляпу',
  },
  {
    id: 'rolling_on_the_floor',
    name: 'rolling_on_the_floor',
    src: rollingOnTheFloorGif,
    unicodeEmojis: ['😂'],
    description: 'Катается по полу от смеха',
  },
  {
    id: 'rose_for_you',
    name: 'rose_for_you',
    src: roseForYouGif,
    unicodeEmojis: ['🌹'],
    description: 'Роза для тебя',
  },
  {
    id: 'sad_faced',
    name: 'sad_faced',
    src: sadFacedGif,
    unicodeEmojis: ['😢'],
    description: 'Грустное лицо',
  },
  {
    id: 'scratches_head',
    name: 'scratches_head',
    src: scratchesHeadGif,
    unicodeEmojis: ['😕'],
    description: 'Чешет голову',
  },
  {
    id: 'shocked',
    name: 'shocked',
    src: shokedGif,
    unicodeEmojis: ['😱'],
    description: 'Шокирован',
  },
  {
    id: 'showing_huge_teeth',
    name: 'showing_huge_teeth',
    src: showingHugeTeethGif,
    unicodeEmojis: ['😁'],
    description: 'Показывает зубы',
  },
  {
    id: 'sigh_of_relief',
    name: 'sigh_of_relief',
    src: sighOfReliefGif,
    unicodeEmojis: ['😌'],
    description: 'Вздох облегчения',
  },
  {
    id: 'smiley_running_away',
    name: 'smiley_running_away',
    src: smileyRunningAwayGif,
    unicodeEmojis: ['🏃'],
    description: 'Убегает',
  },
  {
    id: 'smiley_with_shades',
    name: 'smiley_with_shades',
    src: smileyWithShadesGif,
    unicodeEmojis: ['😎'],
    description: 'В очках',
  },
  {
    id: 'sticking_tongue_out',
    name: 'sticking_tongue_out',
    src: stikingTongueOutGif,
    unicodeEmojis: ['😛'],
    description: 'Показывает язык',
  },
  {
    id: 'thumbs_up',
    name: 'thumbs_up',
    src: thumbsUpGif,
    unicodeEmojis: ['👌'],
    description: 'Окей',
  },
  {
    id: 'tied_up',
    name: 'tied_up',
    src: tiedUpGif,
    unicodeEmojis: ['🤐'],
    description: 'Связан',
  },
  {
    id: 'trying_to_look_innocent',
    name: 'trying_to_look_innocent',
    src: tryingToLookInnocentGif,
    unicodeEmojis: ['👼'],
    description: 'Пытается выглядеть невинно',
  },
  {
    id: 'your_fault',
    name: 'your_fault',
    src: yourFaultGif,
    unicodeEmojis: ['👉'],
    description: 'Твоя вина',
  },
  {
    id: 'simple_smile',
    name: 'simple_smile',
    src: coverMouthGiggleGif,
    unicodeEmojis: ['😊'],
    description: 'Простая улыбка',
  },
  {
    id: 'heart',
    name: 'heart',
    src: beatingHeartGif,
    unicodeEmojis: ['❤️'],
    description: 'Красное сердце',
  },
  {
    id: 'winking_tongue',
    name: 'winking_tongue',
    src: crazyLookingSmileyGif,
    unicodeEmojis: ['😜'],
    description: 'Подмигивание с языком',
  },
  {
    id: 'star_eyes',
    name: 'star_eyes',
    src: crazyLoveGif,
    unicodeEmojis: ['🤩'],
    description: 'Звездные глаза',
  },
  {
    id: 'sick',
    name: 'sick',
    src: notFeelingWellGif,
    unicodeEmojis: ['😷'],
    description: 'Больной',
  },
];

export const unicodeToCustomEmoji: Map<string, CustomEmoji> = new Map();

customEmojis.forEach((emoji) => {
  emoji.unicodeEmojis.forEach((unicode) => {
    unicodeToCustomEmoji.set(unicode, emoji);
  });
});

export const emojiRegex = new RegExp(
  Array.from(unicodeToCustomEmoji.keys())
    .map((emoji) => emoji.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|'),
  'g',
);

export const filterAllowedEmojis = (text: string): string => {
  const emojiRegexAll =
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu;

  return text.replace(emojiRegexAll, (match) => {
    if (unicodeToCustomEmoji.has(match)) {
      return match;
    }
    return '';
  });
};
